import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '@/utils/auth'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const Production = () => import('@/views/Production')
const ThreeNav = () => import('@/views/ThreeNav')
const FourNav = () => import('@/views/FourNav')
const FiveNav = () => import('@/views/FiveNav')
const Demo = () => import('@/views/Demo')
const Buy = () => import('@/views/Buy')
const Invoice = () => import('@/views/Invoice.vue')
const PlatformTour = () => import('@/views/PlatformTour')
const Faq = () => import('@/views/Faq')
const Company = () => import('@/views/Company.vue')
const Jobs = () => import('@/views/Jobs.vue')
const ProductionBrain = () => import('@/components/production/ProductionBrain.vue')
const YunZhaoShang = () => import('@/components/yun_zhaoshang/index.vue')
const EnterInnovation = () => import('@/components/enter_innovation/index.vue')
const Consulting = () => import('@/components/consulting/index.vue')
const ReportList = () => import('@/components/report_list/index.vue')
const NewsDetails = () => import('@/components/report_list/NewsDetails.vue')
const NewsDetailsTwo = () => import('@/components/report_list/NewsDetailsTwo.vue')
const NewsDetailsThree = () => import('@/components/report_list/NewsDetailsThree.vue')
const NewsDetailsFour = () => import('@/components/report_list/NewsDetailsFour.vue')
const NewsDetailsFire = () => import('@/components/report_list/NewsDetailsFire.vue')
const NewsList = () => import('@/views/News.vue')
const Realize = () => import('@/components/realize/index.vue')
const Login = () => import('@/components/login/index.vue')
const ResetPassword = () => import('@/components/reset_password/index.vue')
const Registrier = () => import('@/components/register/index.vue')
const ControlCenter = () => import('@/views/controlCenter/index.vue')


const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:Home
  },
  {
    path:'/login',
    component:Login
  },
  {
    path:'/reset-password',
    component:ResetPassword
  },
  {
    path:'/register',
    component:Registrier
  },
  {
    path:'/controlCenter',
    component:ControlCenter,
    meta: { requiresAuth: true }
  },
  {
    path:'/production',
    component:Production,
    children:[
      {
        path:'1',
        component:ProductionBrain
      },
      {
        path:'2',
        component:YunZhaoShang
      },
      {
        path:'3',
        component:EnterInnovation
      },
      {
        path:'4',
        component:Consulting
      }
    ]
  },
  {
    path:'/threenav',
    component:ThreeNav
  },
  {
    path:'/fournav',
    component:FourNav,
    children:[
      {
        path:'1',
        component:ReportList
      },
      {
        path:'2',
        component:ReportList
      },
      {
        path:'3',
        component:ReportList
      },
    ]
  },
  {
    path:'/fivenav',
    component:FiveNav,
    children:[
      {
        path:'1',
        component:Realize
      },
      {
        path:'2',
        component:Realize
      },
      {
        path:'3',
        component:Realize
      },
      {
        path:'4',
        component:Realize
      }
    ]
  },
  {
    path:'/demo',
    component:Demo
  },
  {
    path:'/buy',
    component:Buy
  },
  {
    path:'/buy/invoice',
    component:Invoice,
    meta: { requiresAuth: true }
  },
  {
    path:'/platform-tour',
    component:PlatformTour
  },
  {
    path:'/news_detail/1',
    component:NewsDetails
  },
  {
    path:'/news_detail/2',
    component:NewsDetailsTwo
  },
  {
    path:'/news_detail/3',
    component:NewsDetailsThree
  },
  {
    path:'/news_detail/4',
    component:NewsDetailsFour
  },
  {
    path:'/news_detail/5',
    component:NewsDetailsFire
  },
  {
    path:'/news',
    component:NewsList
  },
  {
    path:'/faq',
    component:Faq
  },
  {
    path:'/company',
    component:Company
  },
  {
    path:'/jobs',
    component:Jobs
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta && record.meta.requiresAuth) && !isLoggedIn()) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
